import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';

// Lucide icons
import {
  LayoutDashboard,
  BedDouble,
  Home,
  Users,
  Sparkles,
  Bath,
  Heart,
  PhoneCall,
  MessageSquare,
  Settings,
  ChevronLeft,
  ChevronRight,
  GalleryHorizontalEndIcon,
} from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const sidebarClass = isMobile ? (isSidebarOpen ? 'closed' : 'open') : (isSidebarOpen ? 'open' : 'closed');
  const sidebarRef = useRef(null);

  useEffect(() => {
    const savedPosition = sessionStorage.getItem('sidebarScrollPosition');
    if (sidebarRef.current && savedPosition) {
      sidebarRef.current.scrollTop = parseInt(savedPosition, 10);
    }
  }, [location]);

  useEffect(() => {
    const saveScrollPosition = () => {
      if (sidebarRef.current) {
        sessionStorage.setItem('sidebarScrollPosition', sidebarRef.current.scrollTop);
      }
    };
    window.addEventListener('beforeunload', saveScrollPosition);
    return () => {
      saveScrollPosition();
      window.removeEventListener('beforeunload', saveScrollPosition);
    };
  }, []);

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLinkClick = () => {
    if (window.innerWidth < 768) {
      toggleSidebar();
    }
  };

  const menuItems = [
    { path: '/', icon: BedDouble, label: 'Booked Rooms' },
    { path: '/rooms', icon: Home, label: 'Rooms' },
    { path: '/users', icon: Users, label: 'Users' },
    { path: '/key-features', icon: Sparkles, label: 'Key Features' },
    { path: '/amenities', icon: Bath, label: 'Amenities' },
    { path: '/guest-preference', icon: Heart, label: 'Guest Preference' },
    { path: '/contact-request', icon: PhoneCall, label: 'Contacts' },
    { path: '/reviews', icon: MessageSquare, label: 'Reviews' },
    { path: '/gallery', icon: GalleryHorizontalEndIcon, label: 'Gallery' },
  ];

  return (
    <>
      <Header />
      <div className={`sidebar ${sidebarClass}`}>
        <div className="sidebar-list" ref={sidebarRef}>
          <div className="side-bar-header">
            <h1 className={isSidebarOpen ? '' : 'closed'}>HotelEase</h1>
          </div>
          <div className="side-bar-nav">
            <ul>
              {menuItems.map((item, index) => (
                <li key={index} title={isSidebarOpen ? '' : item.label}>
                  <div className="main-menu">
                    <Link
                      to={item.path}
                      onClick={handleLinkClick}
                      className={isActive(item.path) ? 'active-link' : ''}
                    >
                      <item.icon size={20} style={{marginRight:"5px"}}/>
                      <p className={isSidebarOpen ? '' : 'closed'}>{item.label}</p>
                    </Link>
                  </div>
                </li>
              ))}
              {/* Toggle Buttons */}
              <li>
                <button
                  className={`toggle-btn toggle-btn-desk ${isSidebarOpen ? 'open' : 'close'}`}
                  onClick={toggleSidebar}
                >
                  {isSidebarOpen ? <ChevronLeft size={18} /> : <ChevronRight size={18} />}
                </button>
                <button
                  className={`toggle-btn toggle-btn-mob ${isSidebarOpen ? 'open' : 'close'}`}
                  onClick={toggleSidebar}
                >
                  <ChevronLeft size={18} />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
